import { z } from "zod";
export const AvatarSchema = z.object({
    id: z.uuid(),
    url: z.url(),
    createdAt: z.string(),
});
export const AvatarListSchema = z.object({
    avatars: z.array(AvatarSchema),
});
